import React, { Component } from 'react';
import { TwitterPicker } from 'react-color';
import LOOKUP from 'constants/lookup';
import DialogInput from 'screens/components/advanced/DialogInput';
// Basic Components
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import TimePickerInput from 'screens/components/basic/TimePickerInput';
import SelectInput from 'screens/components/basic/SelectInput';
import Button from 'screens/components/basic/Button';
import ToggleInput from 'screens/components/basic/ToggleInput';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';

const componentName = 'scheduleView'

class ScheduleViewDialog extends Component {

    convertDate = (date) => {
        let dateInput = new Date(date);

        let day = (dateInput.getDate() > 9) ? dateInput.getDate() : '0' + dateInput.getDate();
        let month = ((dateInput.getMonth() + 1) > 9) ? (dateInput.getMonth() + 1) : '0' + (dateInput.getMonth() + 1);
        let year = dateInput.getFullYear();

        let newDate = `${year}/${month}/${day}`;

        return newDate;
    }

    convertTime = (time) => {
        let timeInput = new Date(time);
        let hour = (timeInput.getHours() > 9) ? timeInput.getHours() : '0' + timeInput.getHours();
        let minute = (timeInput.getMinutes() > 9) ? timeInput.getMinutes() : '0' + timeInput.getMinutes();

        if(hour > 12) {
            return `${(hour - 12)}:${minute} pm`;
        } else if(hour == 12) {
            return `${hour}:${minute} pm`;
        } else if(hour == 0) {
            return `12:${minute} am`;
        } else {
            return `${hour}:${minute} am`;
        }
    }

    getColor = (color) =>{
        this.setState({...this.state, color: color.hex})
        this.props.formInput(color.hex, `${componentName}Color`)
    }

    render(){
        const p = this.props;
        let color = p.updateColor == "" || p.updateColor == null ? '#893086' : p.updateColor;
        const colors = ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E'];
        if(p.readonly) {

            const actions = [
                <Button
                    key="CancelButton"
                    type="CancelButton"
                    className="btn-space"
                    label={LOOKUP.common.cancel.text}
                    secondary={true}
                    onTouchTap={this.props.handleDialog}
                />
            ];

            return(
                <DialogInput
                        // title="Schedule Details"
                        title={<DialogHeaderWithClose text="Schedule Details" handleClose={() => this.props.handleDialog()} />}
                        modal={true}
                        actions = {actions}
                        className="schedule_dialog"
                        open={p.open}>

                        <div className="row m-0">
                            <div className="col-lg-12 div-span-label">
                                <span><strong>Date:</strong> {this.convertDate(p.schedule && p.schedule.startShift)}</span>
                            </div>

                            <div className="col-lg-6 div-span-label">
                                <span><strong>Start time:</strong> {this.convertTime(p.schedule && p.schedule.startShift)}</span>
                            </div>

                            <div className="col-lg-6 div-span-label">
                                <span><strong>End time:</strong> {this.convertTime(p.schedule && p.schedule.endShift)}</span>
                            </div>
                            <div style={{backgroundColor: color, border:'solid '+color}} width={"10%"}></div>
                            <br/>
                        </div>
                </DialogInput>
            );

        } else {

            const actions = [
                <Button
                    key="CancelButton"
                    type="CancelButton"
                    className="btn-space"
                    label={LOOKUP.common.cancel.text}
                    secondary={true}
                    onTouchTap={this.props.handleDialog}
                />,
                <Button
                    key="ConfirmButton"
                    name="buttonSave"
                    className="pull-right"
                    label="Confirm"
                    primary={true}
                    onTouchTap={this.props.updateSchedule}
                />,
                <Button
                    key="IconDeleteButton"
                    name="buttonDelete"
                    className="pull-left btn-space bg-red"
                    primary={true}
                    label="Delete"
                    onTouchTap={this.props.deleteSchedule}
                />,
                // <Button
                //     key="SaveButton"
                //     name="buttonSave"
                //     className="pull-right mr-2"
                //     label="Cancel"
                //     onTouchTap={this.props.handleDialog}
                // />
            ];

            return(
                <DialogInput
                    title={<DialogHeaderWithClose text="Schedule Details" handleClose={() => this.props.handleDialog()} />}
                    modal={true}
                    actions = {actions}
                    className="schedule_dialog"
                    open={p.open}
                    autoScrollBodyContent={true}
                    >
                    <div className="row m-0">
                        <div className="col-lg-12 pt-4">
                            <ToggleInput
                                className="patient_status width_fit m-auto"
                                name={`${componentName}Status`}
                            />
                        </div>
                        <div className="col-lg-12">
                            <DatePickerInput
                                name={`${componentName}Date`}
                                floatingLabelText={LOOKUP.shiftEdit.date.label}
                                hintText={LOOKUP.shiftEdit.date.hintText}
                                fullWidth={true}
                            />
                        </div>
                        <div className="col-lg-12">
                            <SelectInput
                                name={`${componentName}SelectedCustomTimeSlot`}
                                fullWidth={true}
                                label={LOOKUP.shiftEdit.selectTimeSlot}
                                hintText={LOOKUP.shiftEdit.selectTimeSlot}
                                options={this.props.customTimeSlotsOptions}
                            />
                        </div>
                        <div className="col-lg-6">
                            <TimePickerInput
                                name={`${componentName}Start`}
                                floatingLabelText="Start Time"
                                label="Start Time"
                                hintText="Start Time"
                                fullWidth={true}
                                />
                        </div>
                        <div className="col-lg-6">
                            <TimePickerInput
                                name={`${componentName}End`}
                                floatingLabelText="End Time"
                                label="End Time"
                                hintText="End Time"
                                fullWidth={true}
                            />
                        </div>
                        <div className="col-lg-12">
                            <SelectInput
                                name={`${componentName}Employee`}
                                floatingLabelText="Select Employee"
                                label="Select Employee"
                                hintText="Select Employee"
                                options={p.employeeOptions}
                                fullWidth={true}
                            />
                            <div className="col-lg-12" style={{backgroundColor: color, border:'solid '+color}} width={"10%"}></div>
                            <br/>
                        </div>
                        <div className="col-lg-12">
                            <TwitterPicker width={"auto"}
                                colors={colors}
                                color={color}
                                name={`${componentName}Color`}
                                onChangeComplete={this.getColor}
                            />
                        </div>
                    </div>
                </DialogInput>
            );
        }
    }
}


export default ScheduleViewDialog;
